module.exports = __webpack_public_path__ + "img/ourinfo.d1a59711.webp";